module.exports = __webpack_public_path__ + "img/logo.6138461f.png";